import { useRef } from 'react';

export const useLastDefinedValue = <T>(value: T) => {
  const valueRef = useRef(value);
  const returnedValue = value ?? valueRef.current;
  valueRef.current = returnedValue;
  return returnedValue;
};
